import { Spin } from 'antd';

import styles from './LoadingSpinner.module.less';

export const LoadingSpinner = () => {
  return <Spin className={styles.spinner} />;
};
